export function captureSessionControlObservation(view) {
    return { generation: view?.observationGeneration, availabilityRevision: view?.observationAvailability?.revision };
}
/** Control receipts can survive a storage pause, but cannot establish observation authority. */
export function matchesSessionControlObservation(captured, view) {
    if (!view || view.observationGeneration !== captured.generation || view.observationAvailability?.revision !== captured.availabilityRevision
        || view.observationAvailability && view.observationAvailability.status !== 'available')
        return false;
    if (view.nativeCapabilitiesLive === true)
        return !view.authority || view.authority.status === 'ready';
    return view.authority?.status === 'paused' && view.servicePaused === true && !!view.storageError?.length;
}
//# sourceMappingURL=session-control-receipt.js.map